export const fallbackPlans = [{ id: "daily", name: "GAMEIO DAILY", validityDays: 1, amount: 100 }, { id: "weekly", name: "GAMEIO WEEKLY", validityDays: 7, amount: 300 }];
